var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-user-review-area__list-item__rating-star-list"},_vm._l((_vm.range),function(n){return _c('rating-star',{key:n,attrs:{"selected":_vm.isSelected(n)},on:{"click":function($event){return _vm.onClick(n)}}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }